import classNames from 'classnames';

import { Tag } from 'primereact/tag';

import { InfoSideBar, SkeletonLoader, DataTable } from 'components';

import columns from './columns';

import { ListTwoTicketDetailsUiProps } from './ListTwoTicketDetails.types';

import './list-two-ticket-details.scss';

function TypeColumnTemplate(row: any) {
  return (
    <div
      className={classNames({
        'list-one-ticket-details__type': true,
        'list-one-ticket-details__type--red':
          row.type === 'format' ||
          row.type === 'mandatory' ||
          row.type === 'updated',
      })}
    >
      {row.type}
    </div>
  );
}

export default function ListTwoTicketDetailsUi({
  isLoading,
  isInfoSideBarVisible,
  data,
  handlers,
}: ListTwoTicketDetailsUiProps) {
  return (
    <div className="list-two-ticket-details">
      <div
        className="list-two-ticket-details__slide"
        role="presentation"
        onClick={handlers.handleRowClick}
      />

      <InfoSideBar
        isVisible={isInfoSideBarVisible}
        onClose={handlers.handleSideBarClose}
        ticketDetails={{
          id:
            data.ticketDetails?.id && data.ticketDetails?.id.length > 0
              ? data.ticketDetails?.id
              : data.ticketId,
          type: data.ticketDetails?.type,
          studyId: data.ticketDetails?.studyId,
          employeeId: data.ticketDetails?.employeeId,
          status: data.ticketDetails?.status,
          statusDescription: data.ticketDetails?.statusDescription,
          policyLob: data.ticketDetails?.policy?.lob,
          createdDate: data.ticketDetails?.createdDate,
          updatedDate: data.ticketDetails?.updatedDate,
        }}
      />

      {data.ticketDetails?.policy?.lob && (
        <Tag
          className="list-two-ticket-details__policy-badge"
          value={data.ticketDetails.policy.lob === 'GROUP TERM LIFE' ? 'Life' : 'Health'}
          severity={data.ticketDetails.policy.lob === 'GROUP TERM LIFE' ? 'warning' : 'info'}
        />
      )}

      {data.approvalDocuments.length > 0 && (
        <div className="list-two-ticket-details__documents">
          <h3 className="list-two-ticket-details__documents-title">
            Documents collected before approval
          </h3>
          {data.approvalDocuments.map((document) => (
            <div
              className="list-two-ticket-details__document"
              key={`${document.key}-${document.filename}`}
            >
              <a
                className="list-two-ticket-details__document-link"
                href={document.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {document.filename || document.key}
              </a>
              {document.uploadedByName && (
                <span className="list-two-ticket-details__document-by">
                  {document.uploadedByName}
                </span>
              )}
            </div>
          ))}
        </div>
      )}

      {isLoading ? (
        <SkeletonLoader height="8rem" />
      ) : (
        <DataTable
          sortMode="multiple"
          totalRecords={data.ticketDetails?.fields.length}
          value={data.ticketDetails?.fields}
          columns={columns.map((column) => {
            if (column.field === 'type') {
              return {
                ...column,
                body: TypeColumnTemplate,
              };
            }

            return column;
          })}
        />
      )}
    </div>
  );
}
